import React from 'react'
import { useTranslation } from 'react-i18next'

import { getClassesFromMarginsProp } from '../../utils/utils'

import './size-mix.styles.scss'

const SizeMix = ({ mix, margins, clickHandler, ...otherProps }) => {
  const { t } = useTranslation('updatedBAB')
  const marginClasses = getClassesFromMarginsProp(margins)

  return (
    <div className={`size-mix ${marginClasses}`} onClick={clickHandler}>
      <p className='size-mix-heading'>{t('size.sizeMix.heading')}</p>
      <div className='size-mix-buttons'>
        <button
          className='size-mix-button'
          data-no=''
          data-active={mix ? null : ''}
        >
          {t('size.sizeMix.no')}
        </button>
        <button
          className='size-mix-button'
          data-yes=''
          data-active={mix ? '' : null}
        >
          {t('size.sizeMix.yes')}
        </button>
      </div>
    </div>
  )
}

export default SizeMix
